function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Capa 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  id: "<Compound Path>",
  fillRule: "evenodd",
  className: "hamburger",
  d: "M4 8.25L45.5 8.25C47.71 8.25 49.5 6.46 49.5 4.25C49.5 2.04 47.71 0.25 45.5 0.25L4 0.25C1.79 0.25 0 2.04 0 4.25C0 6.46 1.79 8.25 4 8.25ZM45.5 17.25L4 17.25C1.79 17.25 0 19.04 0 21.25C0 23.46 1.79 25.25 4 25.25L45.5 25.25C47.71 25.25 49.5 23.46 49.5 21.25C49.5 19.04 47.71 17.25 45.5 17.25ZM45.5 34.25L4 34.25C1.79 34.25 0 36.04 0 38.25C0 40.46 1.79 42.25 4 42.25L45.5 42.25C47.71 42.25 49.5 40.46 49.5 38.25C49.5 36.04 47.71 34.25 45.5 34.25Z"
})));

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 43",
    width: 50,
    height: 43,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.c575fdb7.svg";
export { ForwardRef as ReactComponent };